import { styled } from "@mui/material/styles";
import TableRow from "@mui/material/TableRow";

export const TableHeaderRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: "#ffedbb", // lighter gray like Petpooja
  borderRadius: 8,
  boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
  marginBottom: 10,
  overflow: "hidden",
  display: "table",
  width: "100%",
  boxSizing: "border-box",
  borderCollapse: "separate",

  '& th': {
    padding: theme.spacing(1.5, 3),
    fontWeight: 600,
    fontSize: '0.95rem',
    color: "#444",
    borderBottom: "none",
    textTransform: "capitalize",
    textAlign: "left",
  },
}));

export const TableBodyRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: "#fff",
  border: "1px solid #ccc", // full border for each row
  borderRadius: 8,
  '& td': {
    padding: theme.spacing(0, 3),
    borderBottom: "none", // remove default MUI cell border
  },
  // space between rows
  '& + tr': {
    marginTop: theme.spacing(1.5),
  },
  // make row full width
  display: "table",
  width: "100%",
  boxSizing: "border-box",
  borderCollapse: "separate",
}));

export const StyledTableBody = styled('tbody')({
  borderCollapse: 'separate',
  borderSpacing: '0 12px', // gap between rows (adjust as you like)
  width: '100%',
});

export const labelCellStyle = {
  width: "35%",
  textAlign: "right",
  fontWeight: 600,
  color: "#333",
  pr: 1,
  borderBottom: "none",
};

export const colonCellStyle = {
  width: "5%",
  textAlign: "center",
  fontWeight: 700,
  color: "#555",
  borderBottom: "none",
};

export const valueCellStyle = {
  width: "60%",
  textAlign: "left",
  color: "#444",
  borderBottom: "none",
};